export const DEEP_LINK_FEATURES = {
  creditview: 'creditview',
  customcard: 'customcard',
  rewards: 'rewards',
  paymentsecurity: 'payment-security'
} as const

export type DeepLinkFeature =
  (typeof DEEP_LINK_FEATURES)[keyof typeof DEEP_LINK_FEATURES]
